import { useAuth0 } from "@auth0/auth0-react";
import { getCheckFlowScheduleUsage } from "api/FlowsApi";
import { getResourceDependencies } from "api/ResourceDependenciesApi";
import { useUserFlows } from "hooks/useUserFlows";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export const useFlowUsage = (item) => {
   const { user } = useAuth0();
   const { userFlows } = useUserFlows();
   const [invitedUsers, setInvitedUsers] = useState([]);
   const { users } = useSelector((store) => store?.portal?.users);
   const { flows } = useSelector((store) => store?.portal?.flows);
   const [flowUsage, setFlowUsage] = useState({
      isShared: false,
      isScheduled: false,
      isCheckFailed: false,
      invokeFlows: []
   });

   const getUsage = async () => {
      try {
         const checkFlowScheduleUsageResponse = await getCheckFlowScheduleUsage(user?.stripeId, item.id);

         const updatedUsage = {
            isShared: checkFlowScheduleUsageResponse?.resultObject?.isShared,
            isScheduled: checkFlowScheduleUsageResponse?.resultObject?.isScheduled,
            isCheckFailed: false,
            invokeFlows: []
         };

         const dependenciesResponse = await getResourceDependencies({
            tenantId: user?.stripeId,
            sourceId: item.id,
            direction: "reverse"
         });

         if (dependenciesResponse?.isSuccessful === false) {
            throw new Error(dependenciesResponse?.message);
         }

         const dependencies = dependenciesResponse?.resultObject || [];
         const invokingFlowIds = [
            ...new Set(
               dependencies
                  .filter((dependency) => dependency.target_resource_type === "flow")
                  .map((dependency) => dependency.target_id)
            )
         ];
         const scheduleIds = [
            ...new Set(
               dependencies
                  .filter((dependency) => dependency.target_resource_type === "schedule")
                  .map((dependency) => dependency.target_id)
            )
         ];

         updatedUsage.invokeFlows = invokingFlowIds
            .map((flowId) => flows.find((flow) => flow.id === flowId)?.name)
            .filter(Boolean);
         updatedUsage.isScheduled = updatedUsage.isScheduled || scheduleIds.length > 0;

         setFlowUsage(updatedUsage);
         return updatedUsage;
      } catch (error) {
         const failedUsage = {
            isShared: false,
            isScheduled: false,
            isCheckFailed: true,
            invokeFlows: []
         };

         setFlowUsage(failedUsage);
         return failedUsage;
      }
   };

   useEffect(() => {
      if (userFlows?.length) {
         const existingUserflows = userFlows.filter((value) => value.flow_id === item.id);
         const invitedUserIds = existingUserflows.map((existingUserflow) => existingUserflow.user_id);

         setInvitedUsers(users?.filter((user) => user.auth0_id !== user.created_by_id && user.status === "active" && invitedUserIds.includes(user.auth0_id)) || []);

         return;
      }
      setInvitedUsers([]);
   }, [users, userFlows, item.id]);

   return {
      getUsage,
      flowUsage,
      invitedUsers
   };
};
